/**
 * MKS-392 — team name days (jmeniny) and birthdays for the dashboard
 * "Upcoming" card.
 *
 * The DTO is day/month only by design: the backend never sends a birth date,
 * a year or an age (see backend/src/services/upcomingCelebrationsService.ts),
 * so there is nothing here to accidentally render.
 *
 * `birthday` items only ever arrive for an admin or HR caller — the server
 * decides that from the session, not from anything sent here, so there is no
 * audience parameter on this function and adding one would be a bug.
 *
 * Behind `mks_392_upcoming_celebrations`: with the flag off the endpoint 404s
 * and the card never calls it.
 */
import { apiGet } from './client';

export type CelebrationType = 'birthday' | 'nameday';

export interface Celebration {
  type: CelebrationType;
  /** 1-12. */
  month: number;
  /** 1-31. */
  day: number;
  /** Display name, first name and surname. */
  name: string;
}

export function fetchUpcomingCelebrations(days: number): Promise<{ data: Celebration[] }> {
  return apiGet(`/celebrations/upcoming?days=${days}`);
}
